import { render } from "./DailyAnswer.vue?vue&type=template&id=75693b35&scoped=true&ts=true"
import script from "./DailyAnswer.vue?vue&type=script&lang=ts"
export * from "./DailyAnswer.vue?vue&type=script&lang=ts"

import "./DailyAnswer.vue?vue&type=style&index=0&id=75693b35&scoped=true&lang=scss"

import exportComponent from "/data/.jenkins/workspace/k8s-shouba-exhibitionhall-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75693b35"]])

export default __exports__